/**
 * Peta status enum → label Bahasa Indonesia.
 *
 * SATU sumber kebenaran untuk seluruh app. Sebelumnya tiap tempat menampilkan
 * enum mentah (`status.replace(/_/g," ")` + `capitalize`) sehingga bocor teks
 * Inggris ke pengguna: "Published", "Membership Only", "Past Due", "Paid".
 * Sisi siswa bahkan punya 4 implementasi berbeda yang saling tak konsisten.
 *
 * Dipakai: `components/ui/AdminTable.tsx` (StatusBadge, seluruh tabel admin),
 * riwayat transaksi & komisi affiliate siswa.
 */

/** Label per status. Kunci = nilai enum apa adanya dari API/DB. */
const STATUS_LABELS: Record<string, string> = {
  // ── Konten (kelas, produk, webinar, bonus, funnel) ──
  draft: "Draf",
  published: "Terbit",
  archived: "Diarsipkan",
  scheduled: "Terjadwal",
  closed: "Ditutup",

  // ── Umum aktif/nonaktif ──
  active: "Aktif",
  inactive: "Nonaktif",
  disabled: "Dimatikan",

  // ── Pesanan & pembayaran ──
  pending: "Menunggu",
  paid: "Lunas",
  failed: "Gagal",
  cancelled: "Dibatalkan",
  canceled: "Dibatalkan",
  expired: "Kedaluwarsa",
  refunded: "Dikembalikan",
  processing: "Diproses",
  processed: "Selesai",

  // ── Komisi affiliate & payout ──
  approved: "Disetujui",
  rejected: "Ditolak",
  unpaid: "Belum dibayar",
  requested: "Diajukan",

  // ── Membership / akses kelas ──
  revoked: "Dicabut",
  membership_only: "Khusus Member",
  individual: "Beli Satuan",
  free: "Gratis",

  // ── Status langganan tenant (header admin & billing) ──
  past_due: "Jatuh Tempo",
  admin_locked: "Panel Terkunci",
  checkout_disabled: "Checkout Nonaktif",
  suspended: "Ditangguhkan",
  provisioning: "Sedang Disiapkan",
  churned: "Berhenti",
  grace: "Masa Tenggang",

  // ── Peran pengguna ──
  user: "Siswa",
  admin: "Admin",
  super_admin: "Super Admin",

  // ── Email / broadcast ──
  sending: "Mengirim",
  sent: "Terkirim",
  queued: "Antre",
  bounced: "Gagal Kirim",
  paused: "Jeda",

  // ── Invoice ──
  generated: "Dibuat",

  // ── Pendaftaran webinar ──
  registered: "Terdaftar",
  registered_free: "Terdaftar (Gratis)",
  registered_paid: "Terdaftar (Berbayar)",
  share_confirmation_pending: "Menunggu Konfirmasi Share",
  payment_pending: "Menunggu Pembayaran",
};

/**
 * Label Indonesia untuk sebuah status. Status tak dikenal dikembalikan dalam
 * bentuk terbaca (underscore → spasi, huruf awal kapital) agar tidak pernah
 * menampilkan string kosong — dan agar enum baru tetap tampil wajar sebelum
 * ditambahkan ke peta di atas.
 */
export function statusLabel(status: string | null | undefined): string {
  if (!status) return "-";
  const known = STATUS_LABELS[status];
  if (known) return known;
  const readable = status.replace(/_/g, " ");
  return readable.charAt(0).toUpperCase() + readable.slice(1);
}
